export default __webpack_public_path__ + "static/media/icon_descargar.fa2a2cae.svg";